import { Component } from '@angular/core';

@Component({
    selector: 'fcp-store-card',
    templateUrl: './fcp-store-card.component.html',
    styleUrls: ['./fcp-store-card.component.less', '../fcp-card.component.less'],
    standalone: false
})
export class FcpStoreCardComponent {}
